import scanningBlueprints from '~/assets/images/scanning-blueprints-gray.gif'

export default function ProcesingDocuments() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <h3 className="text-center font-semibold">Processing documents...</h3>
      <div className="flex flex-col justify-center">
        <img className="mx-auto grayscale-50" src={scanningBlueprints} width={160} />
      </div>
      <p className="text-center text-sm mt-4 max-w-md">
        You can leave this page and we will continue processing your documents. Come back
        any time to check the status. You will receive an email when your documents are
        ready.
      </p>
    </div>
  )
}
